import { ComponentType } from 'react';
//@ts-ignore
import InvoiceBackground from '@css-xp/base/assets/img/invoice-background.png';
//@ts-ignore
import CustomerAddressBackground from '@css-xp/base/assets/img/customer-address-background.png';
//@ts-ignore
import SubscriptionBackground from '@css-xp/base/assets/img/subscription-background.png';
//@ts-ignore
import CustomerAddressDetailBackground from '@css-xp/base/assets/img/ppc-customer-address-detail-page-bg.png';
//@ts-ignore
import SubscriptionDetailsBackground from '@css-xp/base/assets/img/subscription-details-background.png';
//@ts-ignore
import InvoiceDetailsBackground from '@css-xp/base/assets/img/invoice-details-background.png';
//@ts-ignore
import CloudSiteBackground from '@css-xp/base/assets/img/cloud-site-background.png';
//@ts-ignore
import AccountBalanceBackground from '@css-xp/base/assets/img/billing-account-header.png';
//@ts-ignore
import ImportSubscriptionsBackground from '@css-xp/base/assets/img/import-subscriptions-background.png';
//@ts-ignore
import PPCHeader from '@css-xp/base/assets/img/ppc-header.png';
//@ts-ignore
import PPCHeaderLight from '@css-xp/base/assets/img/ppc-header-light.png';

export enum Background {
  INVOICE_BACKGROUND = 'INVOICE_BACKGROUND',
  CUSTOMER_ADDRESS_BACKGROUND = 'CUSTOMER_ADDRESS_BACKGROUND',
  CUSTOMER_ADDRESS_DETAIL_BACKGROUND = 'CUSTOMER_ADDRESS_DETAIL_BACKGROUND',
  SUBSCRIPTION_BACKGROUND = 'SUBSCRIPTION_BACKGROUND',
  SUBSCRIPTION_DETAILS_BACKGROUND = 'SUBSCRIPTION_DETAILS_BACKGROUND',
  INVOICE_DETAILS_BACKGROUND = 'INVOICE_DETAILS_BACKGROUND',
  CLOUD_SITE_BACKGROUND = 'CLOUD_SITE_BACKGROUND',
  ACCOUNT_BALANCE_BACKGROUND = 'ACCOUNT_BALANCE_BACKGROUND',
  IMPORT_SUBSCRIPTIONS_BACKGROUND = 'IMPORT_SUBSCRIPTIONS_BACKGROUND',
  PPC_HEADER_BACKGROUND = 'PPC_HEADER_BACKGROUND',
  PPC_HEADER_LIGHT_BACKGROUND = 'PPC_HEADER_LIGHT_BACKGROUND',
}

const BackgroundImageMapping: Record<string, ComponentType<{ [svgProp: string]: any }>> = {
  //@ts-ignore
  [Background.INVOICE_BACKGROUND]: InvoiceBackground,
  //@ts-ignore
  [Background.CUSTOMER_ADDRESS_BACKGROUND]: CustomerAddressBackground,
  //@ts-ignore
  [Background.SUBSCRIPTION_BACKGROUND]: SubscriptionBackground,
  //@ts-ignore
  [Background.CUSTOMER_ADDRESS_DETAIL_BACKGROUND]: CustomerAddressDetailBackground,
  //@ts-ignore
  [Background.SUBSCRIPTION_DETAILS_BACKGROUND]: SubscriptionDetailsBackground,
  //@ts-ignore
  [Background.INVOICE_DETAILS_BACKGROUND]: InvoiceDetailsBackground,
  //@ts-ignore
  [Background.CLOUD_SITE_BACKGROUND]: CloudSiteBackground,
  //@ts-ignore
  [Background.ACCOUNT_BALANCE_BACKGROUND]: AccountBalanceBackground,
  //@ts-ignore
  [Background.IMPORT_SUBSCRIPTIONS_BACKGROUND]: ImportSubscriptionsBackground,
  //@ts-ignore
  [Background.PPC_HEADER_BACKGROUND]: PPCHeader,
  //@ts-ignore
  [Background.PPC_HEADER_LIGHT_BACKGROUND]: PPCHeaderLight,
};

export const getBackground: any = (iconKey: string) => {
  return BackgroundImageMapping[iconKey] || '';
};
